<div class="login-body">
  <arc-shared-quantum-login [useBTPanel]="false"></arc-shared-quantum-login>
</div>
